import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";
import {SortType} from "../../../commons/types/sort.type";
import {CommissionDateType} from "../../types/commission-date.type";

export class ConsolidatedCommissionsTableCtrl implements IController {
  excludeMode: any;
  selectedIds: any;
  accountId: string;
  from: string;
  to: string;
  filterDateType?: CommissionDateType;
  statuses: any;
  fromPaid: string;
  toPaid: string;
  archive: boolean;
  ids: string[];
  query: string;
  isPaymentFailed: boolean;
  onSelectChange: Function;
  onView: Function;
  onMarkAsPaid: Function;
  onPay: Function;
  onAttachFile: Function;
  onExportCsv: Function;
  onDelete: Function;

  public consolidatedCommissionsRef: any;
  public loadLimit = 20;
  public infiniteScroll: any;
  public isScrollable: any;
  public selectedKeys: any;
  public sortType: SortType;
  public sortName: string;
  public asceDescIconsMap: any;


  constructor(private $infiniteScroll, private $consolidatedCommission, private commonsConstants, private moment, private $log, private commonsAlertsService: CommonsAlertsService, private $mdMedia) {
  }

  $onInit() {
    this.asceDescIconsMap = this.commonsConstants.sortIconsMap;
    this.consolidatedCommissionsRef = this.$consolidatedCommission();
    this.consolidatedCommissionsRef.$query(this._getQuery());
    this.infiniteScroll = this.$infiniteScroll(this.consolidatedCommissionsRef, this.loadLimit);
    this.selectedKeys = {};
  };

  $onChanges(changes) {
    if (changes.selectedIds) {
      this.selectedKeys = {};
      _.forEach(this.selectedIds, (selectedId) => {
        this.selectedKeys[selectedId] = true;
      });
    }

    if (
      (changes.accountId && !changes.accountId.isFirstChange()) ||
      (changes.from && !changes.from.isFirstChange()) ||
      (changes.to && !changes.to.isFirstChange()) ||
      (changes.filterDateType && !changes.filterDateType.isFirstChange()) ||
      (changes.statuses && !changes.statuses.isFirstChange()) ||
      (changes.fromPaid && !changes.fromPaid.isFirstChange()) ||
      (changes.toPaid && !changes.toPaid.isFirstChange()) ||
      (changes.archive && !changes.archive.isFirstChange()) ||
      (changes.ids && !changes.ids.isFirstChange()) ||
      (changes.query && !changes.query.isFirstChange()) ||
      (changes.isPaymentFailed && !changes.isPaymentFailed.isFirstChange())
    ) {
      this._loadConsolidatedCommissions();
    }
  };

  setEvents() {
    const div1 = document.getElementById('header');
    const div2 = document.querySelectorAll('.md-virtual-repeat-scroller')[0];

    div2.addEventListener('scroll', e => {
      div1.scrollTop = div2.scrollTop;
      div1.scrollLeft = div2.scrollLeft;
    }, {passive: true})
  }


  onToggleSelectAll() {
    this.onSelectChange({selectedIds: [], excludeMode: !this.excludeMode})
  }

  onToggle(consolidatedCommission) {
    this.selectedKeys[consolidatedCommission.id] = !this.selectedKeys[consolidatedCommission.id];
    this.onSelectChange({
        selectedIds: _.keys(_.pickBy(this.selectedKeys, _.identity)),
        excludeMode: this.excludeMode
      }
    );
  }

  private _loadConsolidatedCommissions() {
    this.consolidatedCommissionsRef.$query(this._getQuery())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.commonsAlertsService.somethingWentWrongError();
        this.$log.error('Failed to load billing accounts ', error);
      })
  }

  $doCheck() {
    this.isScrollable = true;
  };

  _getQuery() {
    return {
      limit: this.loadLimit,
      accountId: this.accountId,
      from: this.from,
      to: this.to,
      filterDateType: this.filterDateType,
      status: this.statuses, // Bad naming in server (its a list)
      fromPaid: this.fromPaid,
      toPaid: this.toPaid,
      archive: this.archive,
      id: this.ids,
      searchTerm: this.query,
      isPaymentFailed: !this.isPaymentFailed ? null : this.isPaymentFailed,
      sort: (!!this.sortName && !!this.sortType) ? `${this.sortName},${this.sortType}` : undefined
    }
  }

  onSortChange(sortName, sortType) {
    const isSameSortName = !!sortType && _.isEqual(this.sortType, sortType);
    this.sortType = isSameSortName ? (_.isEqual(this.sortType, SortType.asc) ? SortType.desc : SortType.asc) : SortType.asc;
    this.sortName = sortName;
    this._loadConsolidatedCommissions()
  }
}

angular
  .module('bringoz.admin.commissions')
  .component('consolidatedCommissionsTable', {
    bindings: {
      excludeMode: '<',
      selectedIds: '<?',
      accountId: '<?',
      from: '<?',
      to: '<?',
      filterDateType: '<?',
      statuses: '<?',
      fromPaid: '<?',
      toPaid: '<?',
      archive: '<?',
      ids: '<?',
      query: '<?',
      isPaymentFailed: '<?',
      onSelectChange: '&',
      onView: '&',
      onMarkAsPaid: '&',
      onPay: '&',
      onAttachFile: '&',
      onExportCsv: '&',
      onDelete: '&'
    },
    template: require('./consolidated-commissions-table.html').default,
    controller: ConsolidatedCommissionsTableCtrl
  });
